<template><section><h2>基础散点图</h2>
<block-demo tip="" source="const data = [
  {
    gender: &#39;female&#39;,
    height: 161.2,
    weight: 51.6
  },
  {
    gender: &#39;female&#39;,
    height: 167.5,
    weight: 59
  },
  {
    gender: &#39;female&#39;,
    height: 159.5,
    weight: 49.2
  },
  {
    gender: &#39;female&#39;,
    height: 157,
    weight: 63
  },
  {
    gender: &#39;female&#39;,
    height: 155.8,
    weight: 53.6
  },
  {
    gender: &#39;female&#39;,
    height: 170,
    weight: 59
  },
  {
    gender: &#39;female&#39;,
    height: 159.1,
    weight: 47.6
  },
  {
    gender: &#39;female&#39;,
    height: 166,
    weight: 69.8
  },
  {
    gender: &#39;female&#39;,
    height: 176.2,
    weight: 66.8
  },
  {
    gender: &#39;female&#39;,
    height: 160.2,
    weight: 75.2
  },
  {
    gender: &#39;female&#39;,
    height: 172.5,
    weight: 55.2
  },
  {
    gender: &#39;female&#39;,
    height: 170.9,
    weight: 54.2
  },
  {
    gender: &#39;female&#39;,
    height: 172.9,
    weight: 62.5
  },
  {
    gender: &#39;female&#39;,
    height: 153.4,
    weight: 42
  },
  {
    gender: &#39;female&#39;,
    height: 160,
    weight: 50
  },
  {
    gender: &#39;female&#39;,
    height: 147.2,
    weight: 49.8
  },
  {
    gender: &#39;female&#39;,
    height: 168.2,
    weight: 49.2
  },
  {
    gender: &#39;female&#39;,
    height: 175,
    weight: 73.2
  },
  {
    gender: &#39;female&#39;,
    height: 157,
    weight: 47.8
  },
  {
    gender: &#39;female&#39;,
    height: 167.6,
    weight: 68.8
  },
  {
    gender: &#39;female&#39;,
    height: 159.5,
    weight: 50.6
  },
  {
    gender: &#39;female&#39;,
    height: 175,
    weight: 82.5
  },
  {
    gender: &#39;female&#39;,
    height: 166.8,
    weight: 57.2
  },
  {
    gender: &#39;male&#39;,
    height: 181.6,
    weight: 75.5
  },
  {
    gender: &#39;male&#39;,
    height: 176.5,
    weight: 73
  },
  {
    gender: &#39;male&#39;,
    height: 175,
    weight: 70.2
  },
  {
    gender: &#39;male&#39;,
    height: 174,
    weight: 73.4
  },
  {
    gender: &#39;male&#39;,
    height: 151.6,
    weight: 65.5
  },
  {
    gender: &#39;male&#39;,
    height: 167,
    weight: 53
  },
  {
    gender: &#39;male&#39;,
    height: 155,
    weight: 50
  },
  {
    gender: &#39;male&#39;,
    height: 166,
    weight: 77
  },
  {
    gender: &#39;male&#39;,
    height: 180.3,
    weight: 73.6
  },
  {
    gender: &#39;male&#39;,
    height: 167.6,
    weight: 74.1
  },
  {
    gender: &#39;male&#39;,
    height: 188,
    weight: 85.9
  },
  {
    gender: &#39;male&#39;,
    height: 180.3,
    weight: 73.2
  },
  {
    gender: &#39;male&#39;,
    height: 167.6,
    weight: 76.3
  },
  {
    gender: &#39;male&#39;,
    height: 183,
    weight: 65.9
  },
  {
    gender: &#39;male&#39;,
    height: 183,
    weight: 90.9
  },
  {
    gender: &#39;male&#39;,
    height: 179.1,
    weight: 89.1
  },
  {
    gender: &#39;male&#39;,
    height: 170.2,
    weight: 62.3
  },
  {
    gender: &#39;male&#39;,
    height: 177.8,
    weight: 82.7
  },
  {
    gender: &#39;male&#39;,
    height: 179.1,
    weight: 79.1
  },
  {
    gender: &#39;male&#39;,
    height: 190.5,
    weight: 98.2
  },
  {
    gender: &#39;male&#39;,
    height: 177.8,
    weight: 84.1
  },
  {
    gender: &#39;male&#39;,
    height: 180.3,
    weight: 83.2
  },
  {
    gender: &#39;male&#39;,
    height: 180.3,
    weight: 83.2
  }
]

const { Chart, Axis, Scatter, Legend, Tooltip } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;
})
chart.source(data, {
  row: &#39;gender&#39;,
  text: &#39;height&#39;,
  value: &#39;weight&#39;
})
const scatter = new Scatter({
  showGuideLine: true
})

const axisBottom = new Axis()

const axisLeft = new Axis({ orient: &#39;left&#39; })

const legend = new Legend({ align: [&#39;center&#39;, &#39;bottom&#39;] })

chart.append(
  new Tooltip({
    title: (data) =&gt; data[0].gender,
    formatter: (data) =&gt; {
      console.log(data)
      return `身高：${data.height}CM  体重：${data.weight}KG `
    }
  })
)

chart.append([scatter, legend, axisBottom, axisLeft])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">161.2</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">51.6</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">167.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">59</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">159.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">49.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">157</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">63</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">155.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">53.6</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">170</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">59</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">159.1</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">47.6</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">166</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">69.8</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">176.2</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">66.8</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">160.2</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">75.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">172.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">55.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">170.9</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">54.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">172.9</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">62.5</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">153.4</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">42</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">160</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">50</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">147.2</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">49.8</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">168.2</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">49.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">175</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">157</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">47.8</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">167.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">68.8</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">159.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">50.6</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">175</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">82.5</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'female'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">166.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">57.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">181.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">75.5</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">176.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">175</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">70.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">174</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73.4</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">151.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">65.5</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">167</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">53</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">155</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">50</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">166</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">77</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">180.3</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73.6</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">167.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">74.1</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">188</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">85.9</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">180.3</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">73.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">167.6</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">76.3</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">183</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">65.9</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">183</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">90.9</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">179.1</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">89.1</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">170.2</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">62.3</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">177.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">82.7</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">179.1</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">79.1</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">190.5</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">98.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">177.8</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">84.1</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">180.3</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">83.2</span>
  },
  {
    <span class="hljs-attr">gender</span>: <span class="hljs-string">'male'</span>,
    <span class="hljs-attr">height</span>: <span class="hljs-number">180.3</span>,
    <span class="hljs-attr">weight</span>: <span class="hljs-number">83.2</span>
  }
]

<span class="hljs-keyword">const</span> { Chart, Axis, Scatter, Legend, Tooltip } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'gender'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'height'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'weight'</span>
})
<span class="hljs-keyword">const</span> scatter = <span class="hljs-keyword">new</span> Scatter({
  <span class="hljs-attr">showGuideLine</span>: <span class="hljs-literal">true</span>
})

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis()

<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">align</span>: [<span class="hljs-string">'center'</span>, <span class="hljs-string">'bottom'</span>] })

chart.append(
  <span class="hljs-keyword">new</span> Tooltip({
    <span class="hljs-attr">title</span>: <span class="hljs-function">(<span class="hljs-params">data</span>) =&gt;</span> data[<span class="hljs-number">0</span>].gender,
    <span class="hljs-attr">formatter</span>: <span class="hljs-function">(<span class="hljs-params">data</span>) =&gt;</span> {
      <span class="hljs-built_in">console</span>.log(data)
      <span class="hljs-keyword">return</span> <span class="hljs-string">`身高：<span class="hljs-subst">${data.height}</span>CM  体重：<span class="hljs-subst">${data.weight}</span>KG `</span>
    }
  })
)

chart.append([scatter, legend, axisBottom, axisLeft])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>